<style lang="scss" scoped>
.slide-18 {
  background-image: url("../../../assets/module5/slide18/bg-04.jpg");
  background-size: cover;
  background-position: center;
  padding-top: 20px;
  padding-left: 191px;
  height: calc(100% - 20px);
}
h1 {
  font-size: 197px;
  color: #98c0d7;
  transform: rotate(-5deg);
}
h2 {
  font-size: 66px;
  color: #edad0a;
  margin-top: 10px;
}
.left {
  width: 595px;
  margin-left: 180px;
  margin-top: 10px;
}
.bottom {
  margin-top: 190px;
  width: 992px;
  margin-left: 400px;
}
.btn {
  transition: all 0.2s ease-out;
  width: 250px;
  height: auto;
  display: block;
  position: absolute;
  right: 80px;
  bottom: 300px;
  img {
    width: 100%;
  }
  &:hover {
    transform: scale(1.1);
  }
}
video {
  position: absolute;
  margin: auto;
  top: 134px;
  right: 83px;
  z-index: 9;
  width: 820px;
  height: 458px;
  outline: none !important;
  border-radius: 24px;
}
</style>

<template>
  <div class="slide-18">
    <transition name="fade" appear>
      <video
        v-if="showVideo"
        :src="videoURL"
        controls
        autoplay
        ref="video"
      ></video>
    </transition>
    <transition name="fadeLeft" appear>
      <img
        v-if="slideIndex == 17"
        src="@/assets/module5/slide18/timmy-04.png"
        class="chars"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-if="slideIndex == 17"
        src="@/assets/module5/slide18/video-04.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="scale" appear>
      <div v-if="slideIndex == 17" class="delay-1">
        <h1>Wow</h1>
      </div>
    </transition>
    <transition name="scale" appear>
      <div class="left delay-2" v-if="slideIndex == 17">
        <p>you have completed the FAST Hero’s mission and you are now</p>
        <h2>A fully qualiFIed FAST hero.</h2>
      </div>
    </transition>
    <transition name="scale" appear>
      <div class="bottom delay-3" v-if="slideIndex == 17">
        <p>
          But before you go let’s sing the FAST Hero's song together for the
          first time as fully qualified FAST Heroes.
        </p>
      </div>
    </transition>
    <a href="" class="btn" @click.prevent="playVideo(videoID)">
      <img class="delay-2" src="@/assets/module1/slide16/play_button.svg" />
    </a>
  </div>
</template>

<script>
import { log } from "../../../utils/log";
import vidEnd from "../../../utils/vid";

export default {
  data() {
    return {
      showVideo: false,
      videoURL:
        window?.CF_EBOOK_VARS?.videos?.book_5_video_8?.hd_large?.url ||
        "https://player.vimeo.com/external/372856691.hd.mp4?s=3769c14b17a089b0cb20f3a3e3f85cf3dae9aabb&profile_id=175",
      videoID:
        window?.CF_EBOOK_VARS?.videos?.book_5_video_8?.video_id || "test_id"
    };
  },
  props: ["slideIndex"],
  methods: {
    playVideo(id) {
      log.videoView(id);
      this.showVideo = true;
      vidEnd(this);
    }
  }
};
</script>
